import type { ComponentType, SVGProps } from 'react'
import type { Theme } from '@mui/material/styles'
import { PaymentTiming } from '@/types/enums/PaymentTiming'
import {
  BanknoteIcon,
  CheckmarkCircleIcon,
  InfoCircleIcon,
  TakeawayBagIcon,
} from '@/components/icons'
import { getPaymentTimingColor } from '@/utils/payment-timing'

/** Customer-facing payment timing labels (presentation only; enum unchanged). */
export const PaymentTimingCustomerLabel: Record<PaymentTiming, string> = {
  [PaymentTiming.Unknown]: 'Unknown',
  [PaymentTiming.BeforeFulfillment]: 'Prepaid Order',
  [PaymentTiming.AtDelivery]: 'COD Order',
  [PaymentTiming.AtPickup]: 'Pay at Pickup',
}

export function getPaymentTimingCustomerLabel(timing: PaymentTiming): string {
  return PaymentTimingCustomerLabel[timing]
}

type PaymentTimingIcon = ComponentType<SVGProps<SVGSVGElement>>

const PAYMENT_TIMING_ICON: Record<PaymentTiming, PaymentTimingIcon> = {
  [PaymentTiming.Unknown]: InfoCircleIcon,
  [PaymentTiming.BeforeFulfillment]: CheckmarkCircleIcon,
  [PaymentTiming.AtDelivery]: BanknoteIcon,
  [PaymentTiming.AtPickup]: TakeawayBagIcon,
}

export type PaymentTimingIndicatorPresentation = {
  label: string
  Icon: PaymentTimingIcon
  accentColor: string
}

/** Single source of truth for payment timing indicator (label, icon, accent). */
export function resolvePaymentTimingIndicatorPresentation(
  timing: PaymentTiming,
  theme: Pick<Theme, 'palette'>
): PaymentTimingIndicatorPresentation {
  return {
    label: getPaymentTimingCustomerLabel(timing),
    Icon: PAYMENT_TIMING_ICON[timing] ?? InfoCircleIcon,
    accentColor: getPaymentTimingColor(timing, theme),
  }
}
